import { render, staticRenderFns } from "./t-app-menu.vue?vue&type=template&id=09947526&"
import script from "./t-app-menu.vue?vue&type=script&lang=js&"
export * from "./t-app-menu.vue?vue&type=script&lang=js&"
import style0 from "./t-app-menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports